import { SUGGESTION_QUERIES } from "../../lib/copilotResponseCache";

export function SuggestionChips({ onSelect }) {
  return (
    <div className="cop-suggestions">
      {SUGGESTION_QUERIES.map((s) => (
        <button key={s} type="button" className="cop-chip" onClick={() => onSelect(s)}>
          {s}
        </button>
      ))}
    </div>
  );
}
